import { render, staticRenderFns } from "./match-player-card.vue?vue&type=template&id=6720c234&scoped=true&"
import script from "./match-player-card.vue?vue&type=script&lang=js&"
export * from "./match-player-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720c234",
  null
  
)

export default component.exports